import { required } from 'vuelidate/lib/validators'

const minDate = (value) => {
  if (!value) return true
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const inputDate = new Date(value)
  inputDate.setHours(0, 0, 0, 0)
  return inputDate >= today
}

const greaterThanStartDate = (value, vm) => {
  if (!value || !vm.startAtUtc) return true
  const endDate = new Date(value)
  const startDate = new Date(vm.startAtUtc)
  return endDate > startDate
}

export default {
  provide: function () {
    return {
      $vv: this.$v
    }
  },
  validations: {
    innerEntity: {
      title: {
        required
      },
      caption: {
        required
      },
      type: {
        required
      },
      message: {},
      linkText: {},
      linkUrl: {},
      startAtUtc: {
        required,
        minDate
      },
      endAtUtc: {
        required,
        greaterThanStartDate
      }
    }
  }
}

